module.exports = __webpack_public_path__ + "img/SAP_8693.053cd2ce.jpg";